export default __webpack_public_path__ + "static/media/site_2.2784ea82.png";